export default () => ({
    confirmModalBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        margin: '16px 0',
    },
    confirmModalWarningMarkdown: {
        '& strong': {
            fontWeight: 500,
        },
    },
    modalLoader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        height: '100%',
        width: '100%',
    },
});
